import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// for more info => https://github.com/reduxjs/cra-template-redux-typescript

export interface PermissionState {
    permissions: string[];
    // false tot de rechten uit het token gelezen zijn (kort na het laden van de app)
    loaded: boolean;
}

const initialState: PermissionState = {
    permissions: [],
    loaded: false,
};

export const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setPermission: (state, action: PayloadAction<string[]>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.permissions = action.payload;
      state.loaded = true;
    },
  },
});

export const { setPermission } = permissionSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const getPermissions = (state: RootState) => state.permission.permissions;

export const getPermissionsLoaded = (state: RootState) => state.permission.loaded;

export default permissionSlice.reducer;
